import { Fragment } from "react";
import { keyLabel, type Shortcut } from "@/shared/keyboard/shortcuts";

/** As teclas de um atalho como `<kbd>`: "G depois M", "⌘ + B". */
export function ShortcutKeys({ item }: { item: Shortcut }) {
  return (
    <span className="shortcut-keys">
      {item.keys.map((key, index) => (
        <Fragment key={`${key}-${index}`}>
          {index > 0 && <span className="shortcut-then">{item.sequence ? "depois" : "+"}</span>}
          <kbd>{keyLabel(key)}</kbd>
        </Fragment>
      ))}
    </span>
  );
}
